import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { verifyMymazdaEmail } from 'apis/mymazda'
import { withRadium, gtmEvent } from 'higher-order-components'
import { FORM_ERRORS } from 'constants/errors'
import { InputText, WysiwygContent, CancelIcon, ErrorIcon } from 'components'
import { get, PLACEHOLDER as _, onKeyPress } from 'utils'
import { required, validateEmail } from 'utils/validation'
// Redux
import { gtmMyMazdaRegisterActionTypes } from 'store/gtm-events'

import Form from 'components/forms'
import FormSection from 'components/forms/form-section'
import SubmitSection from 'components/forms/submit-section'


const onEnter = onKeyPress(['Enter'])

export class EditEmailAddress extends Form {
  constructor(props) {
    super(props)

    this.state = {
      displayThankYou: false,
      showPassword: false,
      fields: {}
    }
  }

  submitMapping = (fields = {}) => {
    const getVal = get(_, fields)
    return {
      NewEmail: getVal('email.value')
    }
  }

  handleSubmit = (event) => {
    this.submit(
      this.props.changeEmailEndpoint,
      this.state.fields,
      this.submitMapping,
      {},
      verifyMymazdaEmail
    )
  }

  render() {
    const { displayThankYou, fields, showPassword } = this.state
    const { onUpdate, description } = this.props

    if (displayThankYou) {
      onUpdate({ success: true })
      return null
    }

    return (
      <div data-test="mymazda-change-email-form">
        <div style={styles.container}>
          <div style={styles.content}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={styles.label}>CHANGE EMAIL</span>
              <span onClick={onUpdate} style={styles.cancel}>
                <CancelIcon style={styles.cancelIcon} />
                Cancel
              </span>
            </div>
            <FormSection marginTop={'0'}>
              <InputText
                label={'Email'}
                type={'text'}
                onKeyPress={onEnter(this.handleSubmit)}
                {...this.linkState(
                  'email',
                  required(validateEmail, FORM_ERRORS.EMAIL_REQUIRED)
                )}
              />
              <WysiwygContent>
                <p>
                  {description}
                </p>
              </WysiwygContent>
            </FormSection>

            <SubmitSection
              buttonText={this.props.buttonText}
              onSubmit={this.handleSubmit}
              canSubmit={this.canSubmit()}
              errorMessages={[this.state.errorMessages, this.state.error]}
              submitting={this.state.submitting}
            />
          </div>
        </div>
      </div>
    )
  }
}

EditEmailAddress.propTypes = {
  buttonText: PropTypes.string,
  fields: PropTypes.object,
  onUpdate: PropTypes.func,
  passwordInputLabel: PropTypes.string,
  linkState: PropTypes.func,
  gtmEvent: PropTypes.func
}

EditEmailAddress.defaultProps = {
  buttonText: 'Send Verification Email'
}

const styles = {
  container: {
    boxSizing: 'content-box',
    maxWidth: '24em',
    margin: '1.5em auto 0',
    textAlign: 'left'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  heading: {
    color: '#191919',
    marginBottom: '1em',
    textAlign: 'center'
  },
  label: {
    color: '#aaa',
    fontSize: '80%',
    margin: '0',
    display: 'inline-block',
    fontWeight: '600',
    letterSpacing: '.2em'
  },
  cancel: {
    color: '#aaa',
    fontSize: '90%',
    margin: '0',
    display: 'inline-block',
    cursor: 'pointer',
    fontWeight: '400',
    letterSpacing: 'inherit',
    ':hover': { color: '#191919' }
  },
  cancelIcon: {
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    marginRight: '0.5em'
  }
}

export default withRadium(gtmEvent())(EditEmailAddress)



// WEBPACK FOOTER //
// ./src/containers/mymazda/manage-account/edit-email-address.jsx